// src/index.js
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App.js';
import 'regenerator-runtime/runtime';
import '@babel/polyfill';
import '../css/app.css';

ReactDOM.render(<App />, document.getElementById('root'));
